// extracted by mini-css-extract-plugin
module.exports = {"nav-list":"nav-list___devsite","mds-section__header-container":"mds-section__header-container___devsite","mds-section":"mds-section___devsite"};